import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { ProjectService } from '../../../../services/ProjectService';
import { toast } from 'react-toastify';
import { IoIosFolder } from 'react-icons/io';

export default function EmpolyeeSubFolder() {
  const { id,mainFolderId } = useParams();
  const navigate = useNavigate();
  const [folders, setFolders] = useState([]);
  const [subFolderDetails, setFolderDetails] = useState("");

  useEffect(() => {
      const fetchFolders = async () => {
        try {
          const result = await ProjectService.getProjectSubFolders(id,mainFolderId);
          if (result) {
            setFolders(result);
            // console.log("Subfolders ",result);           
          }
        } catch (error) {
          toast.error(error?.message);
        }
      };
      fetchFolders();
  }, [id,mainFolderId]);

  useEffect(() => {
      const fetchMainFolderDetail = async () => {
        try {
          const result = await ProjectService.getProjectAndMainFolderByMainFolderId(mainFolderId);
          if (result) {
            setFolderDetails(result);
            // console.log("main folder ",result);           
          }
        } catch (error) {
          toast.error(error?.message);
        }
      };
      fetchMainFolderDetail();
  }, [mainFolderId]);


  return (
    <div className="p-6">
      <div
      onClick={()=>navigate(-1)} 
      className="pb-6">
        <p className='capitalize hover:underline hover:text-blue-500 text-base lg:text-lg font-semibold'>
          {subFolderDetails.projectName} {">"} {subFolderDetails.mainFolderName} 
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-5 bg-white p-8">
        {folders.map((folder) => (
          <div
            key={folder.id}
            onClick={() => navigate(`/emp-projects/user-doc/documents/${id}/${mainFolderId}/${folder.id}`)}
            className="border rounded-lg p-5 hover:shadow-md cursor-pointer"
          >
            <div className="flex flex-col items-center gap-3 ">
              <div className="h-24 w-24">
                <IoIosFolder className="w-full h-full text-[#F4B400]" />
              </div>
              <h2 className="text-center max-w-full break-all px-4">
                {folder.name}
              </h2>
            </div>
          </div>
        ))}

        {folders.length === 0 && (
          <p className="col-span-full text-center text-gray-500">
            No folders found
          </p>
        )}
      </div>
    </div>
  )
}
